import { motion } from 'motion/react';
import styled from 'styled-components';
import { COLORS, device } from '../../../constants';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

export const MotionSecondaryHeaderLogoWrapper = styled(motion.div)`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 243px;
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    border: 1.5px dashed ${COLORS.ACTIVE_ITEM};
    opacity: 0;
    transform: scale(1);
    pointer-events: none;
    z-index: 0;
    animation: pulse-ring infinite;
    animation-duration: ${ANIMATION_CONFIG.keyFrames.secondaryHeader.duration}s;
    animation-delay: ${ANIMATION_CONFIG.keyFrames.secondaryHeader.delay}s;
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);

    @media screen and (${device.lg}) {
      width: 200px;
    }
    @media screen and (${device.bsm}) {
      width: 120px;
    }
  }

  @keyframes pulse-ring {
    0% {
      transform: scale(1);
      opacity: 0;
    }
    12.5% {
      transform: scale(1.5);
      opacity: 1;
    }
    25% {
      transform: scale(1.5);
      opacity: 1;
    }
    37.5% {
      transform: scale(2);
      opacity: 0.5;
    }
    50% {
      transform: scale(2);
      opacity: 0.5;
    }
    62.5% {
      transform: scale(3);
      opacity: 0;
    }
    75% {
      transform: scale(3);
      opacity: 0;
    }
    87.5% {
      transform: scale(3);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
`;
